module.exports = __webpack_public_path__ + "static/media/SO2_VISUALIZED.b8321283.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/utils/legend/SO2_VISUALIZED.PNG
// module id = 1086
// module chunks = 0